(ns practitest.frontend.landing.views
  (:require [practitest.frontend.landing.project-list :as project-list]
            [practitest.frontend.landing.assigned-to-me :as assigned-to-me]
            [practitest.frontend.landing.last-actions :as last-actions]
            [practitest.frontend.landing.account-info :as account-info]
            [practitest.frontend.landing.whats-new :as whats-new]))

(defn main-panel []
  [:div
   [project-list/project-list]
   [account-info/account-info]
   [:div.pt-landing-row-container
    [:div.pt-landing-row
     [assigned-to-me/assigned-to-me]
     [last-actions/last-actions]]]

   [whats-new/whats-new]])
